import React, { useMemo } from 'react';

import { Box, Container } from '@brand/components';

import { Highlight } from '@domain/entities';

import { Highlights } from '@hoa/organisms';

import { useTranslation } from '@hoa/hooks';

interface Props {
  highlight: Highlight | undefined;
}

export const CategoryHighlights = (props: Props): JSX.Element => {
  const { locale, t } = useTranslation();

  const highlights = useMemo<Highlight[]>(
    () =>
      t(`common:highlights`, {
        ...(props.highlight || { sr_count: 61108, trader_count: 3153 }),
        returnObjects: true,
      }) as Highlight[],
    [locale]
  );

  return (
    <Box as="section" py={6} bg="white">
      <Container>
        <Highlights highlights={highlights} />
      </Container>
    </Box>
  );
};
